<template>
  
    <div class="flex flex-col lg:flex-row flex-wrap">

        <div v-for="(oneInstructor) in instructor" :key="oneInstructor.id" class="lg:mx-4" >

            <!-- <div>

                <button v-if="canCancel"
                    class="mr-2 lg:mr-5 px-1 lg:px-4 py-2 bg-red-500 shadow-lg border rounded-lg text-white w-24 lg:w-48    
                    uppercase font-semibold tracking-wider focus:outline-none focus:shadow-outline hover:bg-red-400 active:bg-red-400"
                    @click="showInfoMethod(oneInstructor)"> <label>View</label></button>
            </div> -->

            <div>
                
                <instructor-card :myInstructor="oneInstructor" :showInfoMethod="showInfoMethod"
                :showSessionsMethod="showSessionsMethod"/>
            </div>
        </div>
    </div>

</template>

<script>

import InstructorCard from '../cards/CustomerInstructorCard';

export default {

    props:{

        instructor: {

            type: Array,
        },

        showInfoMethod: {

            type: Function
        },

        showSessionsMethod: {

            type: Function
        },
    },

    components:{

        InstructorCard
    }

}
</script>

<style>

</style>